export default [
  {
    path: "/refrigerationList",
    name: "冷库列表",
    component: () =>
      import("../views/shareContent/refrigerationHouse/index.vue"),
  },
  {
    path: "/farmMachineryList",
    name: "农机列表",
    component: () => import("../views/shareContent/farmMachinery/index.vue"),
  },
];
